import React, { useState, useEffect } from "react";
import { Button, Input, Space, } from 'antd';
import { LockOutlined } from "@ant-design/icons";

function Newsletter() {
  const [containerStyle, setContainerStyle] = useState({
    backgroundColor: "#f0f0f0",
    padding: "80px 110px",
    height: "auto",
    textAlign: "center"
  });

  const [inputStyle, setInputStyle] = useState({
    width: '30%',
    marginTop: "15px",
    margin: "0 auto"
  });

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        // Mobile view
        setContainerStyle({
          backgroundColor: "#f0f0f0",
          padding: "40px 20px",
          height: "auto",
          textAlign: "center"
        });
        setInputStyle({
          width: '100%',
          marginTop: "15px",
          margin: "0 auto"
        });
      } else if (window.innerWidth <= 1024) {
        // Tablet view
        setContainerStyle({
          backgroundColor: "#f0f0f0",
          padding: "60px 40px",
          height: "auto",
          textAlign: "center"
        });
        setInputStyle({
          width: '70%',
          marginTop: "15px",
          margin: "0 auto"
        });
      } else {
        // Desktop view
        setContainerStyle({
          backgroundColor: "#f0f0f0",
          padding: "80px 110px",
          height: "auto",
          textAlign: "center"
        });
        setInputStyle({
          width: '30%',
          marginTop: "15px",
          margin: "0 auto"
        });
      }
    };

    // Set initial styles based on current window size
    handleResize();

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div style={containerStyle}>
      <h2 style={{
        fontSize: "36px",
        fontWeight: "bold",
        lineHeight: "48px",
        marginBottom: "10px"
      }}>Connect with Optix360</h2>
      <p style={{
        fontSize: "16px",
        lineHeight: "24px",
        color: "rgb(75 85 99)",
        maxWidth: "600px",
        margin: "0 auto 20px auto"
      }}>Subscribe to our newsletter to get the latest news and updates.</p>

      <Space.Compact style={inputStyle}>
        <Input
          placeholder="Enter your email"
          style={{
            height: "50px",
          }}
        />
        <Button
          type="primary"
          style={{
            backgroundColor: "#000",
            border: "none",
            height: "50px"
          }}
        >
          Subscribe
        </Button>
      </Space.Compact>

      <p style={{
        fontSize: "14px",
        lineHeight: "24px",
        color: "rgb(75 85 99)",
        marginTop: "10px"
      }}>
        <span><LockOutlined style={{ marginRight: "5px" }}></LockOutlined></span>
        We prioritize your privacy and do not share or sell your email address.
      </p>
    </div>
  )
}

export default Newsletter;